/** Homepage sections: consistent max width + horizontal padding (1200px / 24px). */
export const homepageSectionContainerClassName = 'max-w-[1200px] mx-auto px-6';

/** Vertical rhythm for stacked homepage sections (below hero). */
export const homepageSectionPaddingYClassName = 'py-14 lg:py-[4.5rem]';

/** Premium surface — trust cards, stat panels. */
export const homepageElevatedPanelClassName =
  'rounded-xl border border-[rgba(0,227,255,0.14)] bg-[linear-gradient(180deg,rgba(0,227,255,0.055)_0%,transparent_52%),#0A0E13]';

/** Category proof stat bar outer shell. */
export const homepageCategoryStatBoxClassName =
  'mt-1 rounded-[10px] border border-[rgba(0,227,255,0.28)] bg-[rgba(0,227,255,0.02)] px-3 py-0 shadow-[0_0_14px_rgba(0,227,255,0.08)] transition-shadow duration-200 hover:shadow-[0_0_14px_rgba(0,227,255,0.22)] sm:px-4';

/** Footer Explore + Legal: no default underline; hover text + LTR animated underline (#00e3ff). */
export const footerLinkClassName =
  'relative block w-fit max-w-full text-sm text-gray-400 no-underline transition-colors duration-300 ease-out hover:text-[#00e3ff] after:pointer-events-none after:absolute after:left-0 after:bottom-0 after:h-px after:w-0 after:bg-[#00e3ff] after:transition-[width] after:duration-300 after:ease-out hover:after:w-full';

/** Replace with listing URLs when the app pages are live. */
export const PIXANO_APPLE_STORE_URL = "https://apps.apple.com/us/app/pixano/id6758970941";
export const PIXANO_GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=ai.pixano.pix";

/** Hero + primary: white text, transparent bg, brand border — aligned with store / nav hover. */
export const homepagePrimaryButtonClassName =
  'inline-flex items-center justify-center rounded-lg border border-[#00e3ff] bg-transparent px-6 py-3 text-sm font-medium text-white transition-all hover:border-[#00e3ff] hover:bg-[rgba(0,227,255,0.1)] hover:shadow-[0_0_14px_rgba(0,227,255,0.28)]';

/** Store / secondary — hero border + fill hover + subtle cyan glow. */
export const storeButtonClassName =
  'inline-flex items-center justify-center px-4 py-2 sm:px-5 sm:py-2.5 rounded-md border border-[#00e3ff] bg-transparent text-xs sm:text-sm font-medium text-white transition-all whitespace-nowrap hover:bg-[rgba(0,227,255,0.1)] hover:border-[#00e3ff] hover:shadow-[0_0_14px_rgba(0,227,255,0.35)]';

/** Nav Login — same outline system as hero / store (rounded-lg, py-2 ~ hero height). */
export const navLoginButtonClassName =
  'inline-flex items-center justify-center rounded-lg border border-[#00e3ff] bg-transparent px-4 py-2 text-sm font-medium text-white transition-all hover:bg-[rgba(0,227,255,0.1)] hover:border-[#00e3ff] hover:shadow-[0_0_14px_rgba(0,227,255,0.35)]';

/** Micro link under category blocks → Request dataset */
export const homepageDatasetRequestLinkClassName =
  'inline-flex items-center gap-1 text-xs font-normal text-[#00e3ff]/80 decoration-transparent underline-offset-4 transition-colors hover:text-[#00e3ff] hover:underline hover:decoration-[#00e3ff]/40 sm:text-[13px]';

export const sectionHeadingAccentClassName =
  'relative pb-3 after:absolute after:left-0 after:bottom-0 after:h-px after:w-10 after:max-w-[2.5rem] after:bg-[#00e3ff]/35';

export const sectionHeadingAccentCenterClassName =
  'relative pb-3 after:absolute after:left-1/2 after:-translate-x-1/2 after:bottom-0 after:h-px after:w-10 after:max-w-[2.5rem] after:bg-[#00e3ff]/35';
